<div class="zoom-actived" >
	<img [src]="focusMediaValue" class="image-zoom py-4"/>
  <div (click)="closeZoomImage()"
  class="h-12 w-12 flex justify-center items-center absolute bg-gray-100 bg-opacity-50 rounded-default ion-activatable ripple-parent cursor-pointer"
  style="top: 10px; right: 10px"  >
    <ion-ripple-effect class="rounded-full"></ion-ripple-effect>
    <ion-icon name="close" class="text-2xl"></ion-icon>
	</div>
</div>
